import currentUserPreload from "./current-user-preload.json"

export default currentUserPreload
